/*=========================================================================================
  File Name: moduleTypologyMutations.js
  Description: Typology Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default {
	SAVE_UPLOAD(state, data) {
		state.uploads.unshift(data);
		state.upload = data;
	},
	SAVE_UPLOAD_FILE(state, data) {
		state.uploadedFiles = data;
	},
	SET_UPLOAD_FILE_PAGINATION(state, pagination) {
		//state.pagination = data.pagination
		Object.assign(state.pagination, pagination);
	},
	SET_SKILLS(state, skills) {
		state.skills = skills;
	},
	SET_EQUIVALENTS(state, data) {
		state.equivalents = {...state.equivalents, ...data};
	},
	UPDATE_EQUIVALENTS(state, data) {
		state.equivalents = {...state.equivalents, ...data};
	},
	UPDATE_UPLOAD(state, {itemId, total_routes}) {
		const ItemIndex = state.uploadedFiles.findIndex((t) => t.id === itemId);
		Object.assign(state.uploadedFiles[ItemIndex], {total_routes});
	},
	REMOVE_UPLOAD(state, itemId) {
		const ItemIndex = state.uploadedFiles.findIndex((t) => t.id === itemId);
		state.uploadedFiles.splice(ItemIndex, 1);
	},
	SET_DATARUTAS_FILE(state, val) {
		state.datarutas_file = val;
	},
	SET_CAPACITIES_NAMES(state, capacityNames) {
		state.capacityNames = capacityNames;
	},
};
